import React from 'react';
import { AppFormLayout, AppForm, AppFormPageProps, AppFormItemEnum, AppAction } from 'qcc'
import { appEnum } from 'utils/appEnum'
import api, { AppUser } from 'api'
import { AppOrgan } from '../../../api/index';

const sexOptions = [{ label: '男', value: '1' }, { label: '女', value: '2' }]

interface UserEditProps extends AppFormPageProps {
  organList: AppOrgan[]
}

export default class UserEdit extends React.PureComponent<UserEditProps> {
  state = { companyId: this.props.formData.companyId }

  save = async (formData: AppUser) => {
    let { companyId } = this.state
    formData = { ...formData, companyId }
    console.log('formData:', formData)
    return this.props.mode === 2 ? await api.appuser.update(formData) : await api.appuser.create(formData);
  }

  afterSave = () => {
    this.props.afterSave && this.props.afterSave();
    AppAction.closeDialog();
  }

  changeOrgan = (formData?: AppUser) => {
    let { organList } = this.props
    let organ = organList.find((o: AppOrgan) => o.id.toString() === formData.organId.toString()) || {}
    let companyId = organ.organType === 2 ? organ.parentId : organ.id;

    this.setState({ companyId })
  }

  refForm = React.createRef<AppForm>();
  render() {
    let { formData, mode, id, organList } = this.props;
    return (<AppFormLayout defaultButton>
      <AppFormLayout.Form>
        <AppForm loadingData={false}
          ref={this.refForm}
          save={this.save}
          mode={mode}
          keyValue={id}
          formData={formData}
          afterSave={() => { this.afterSave() }}>
          <AppForm.Section labelWidth={100}>
            <AppForm.Item field='name' itemType={AppFormItemEnum.input} label="用户名称" req />
            <AppForm.Item field='account' itemType={AppFormItemEnum.input} label="账号" req />
            <AppForm.Item field='organId' itemType={AppFormItemEnum.select} label="所属组织" onFormItemChange={this.changeOrgan} options={organList.map((organ) => {
              return { label: organ.name, value: organ.id.toString() }
            })} req />
            <AppForm.Item field='email' itemType={AppFormItemEnum.input} label="邮箱" />
            <AppForm.Item field='mobile' itemType={AppFormItemEnum.input} label="手机号" />
            <AppForm.Item field='adUser' itemType={AppFormItemEnum.radio} label="是否域用户" dataType="boolean" />
            {mode === 1 ? <AppForm.Item render={() => { return '初始密码为：123456' }} readonly labelHidden /> : null}
          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
    </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/application/user/UserEdit.tsx